import { useEffect } from "react";
import { gsap } from "gsap";

interface MoveRightAnimationProps {
    svgElement: SVGElement;
    animationSpeed: number;
    moveDistance: number,
  }
  const MoveRightAnimation: React.FC<MoveRightAnimationProps> = ({
    svgElement,
    moveDistance = 20,
    animationSpeed = 1,
  }) => {
    useEffect(() => {
      gsap.to(svgElement, {
        x: `+=${moveDistance}`,
        duration: animationSpeed,
        ease: "power1.inOut",
        repeat: -1,
        yoyo: true,
      });
    }, [svgElement, moveDistance, animationSpeed]);
  
    return null;
  };  
  
export default MoveRightAnimation;
